<script setup lang="ts">
const atmosphereStyle = {
    background: `
        radial-gradient(ellipse 80% 60% at 15% 20%, rgba(181, 115, 5, 0.35), transparent 55%),
        radial-gradient(ellipse 70% 50% at 85% 80%, rgba(92, 58, 20, 0.45), transparent 50%),
        linear-gradient(160deg, #1c130c 0%, #0f0b07 45%, #24170f 100%)
    `,
}

const noiseStyle = {
    backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
}
</script>

<template>
    <div class="relative min-h-dvh overflow-hidden bg-[#140e09] text-[#f7f1e8]">
        <div class="pointer-events-none absolute inset-0 animate-auth-pan">
            <div class="absolute inset-0" :style="atmosphereStyle" />
            <div class="absolute inset-0 opacity-[0.07]" :style="noiseStyle" />
        </div>

        <div
            class="relative z-10 mx-auto grid min-h-dvh w-full max-w-6xl items-center gap-10 px-6 py-12 lg:grid-cols-2 lg:gap-16 lg:px-10"
        >
            <div class="animate-auth-fade-in flex flex-col justify-center text-center lg:text-left">
                <img
                    src="/images/antahan-logo.svg"
                    alt="Antahan Café"
                    class="mx-auto h-16 w-auto drop-shadow-lg lg:mx-0 lg:h-20"
                />
                <h1
                    class="mt-6 font-josefin text-5xl font-bold uppercase leading-[1.05] tracking-wide text-[#f4e6d0] sm:text-6xl lg:text-7xl"
                >
                    Antahan
                    <span class="block text-[rgb(212_160_70)]">Café</span>
                </h1>
                <p class="mx-auto mt-5 max-w-md text-base leading-relaxed text-[#d8c7ae]/85 lg:mx-0">
                    Quality coffee, genuine hospitality — for the team behind every cup.
                </p>
            </div>

            <div
                class="animate-auth-fade-up mx-auto w-full max-w-md lg:mx-0 lg:justify-self-end"
                style="animation-delay: 120ms"
            >
                <div
                    class="rounded-2xl border border-[#c9a56a]/20 bg-[#1a130e]/75 p-6 shadow-[0_24px_80px_rgba(0,0,0,0.45)] backdrop-blur-md sm:p-8"
                >
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>
